module.exports = __webpack_public_path__ + "static/media/LakelandRegional.6636140e.png";